import { Box, Typography, useTheme } from '@mui/material'
import { darken } from '@mui/material/styles'
import React, { FC, ReactElement, useCallback } from 'react'
import { colors } from '../../theme/options'

interface PlatformSelectBoxProps {
  'data-testid'?: string
  color: string
  title: string
  icon: ReactElement
  onClick: () => void
}

export const PlatformSelectBox: FC<PlatformSelectBoxProps> = ({
  'data-testid': testid,
  color,
  title,
  icon,
  onClick,
}) => {
  const theme = useTheme()

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onClick()
      }
    },
    [onClick],
  )

  return (
    <Box
      data-testid={testid}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={title}
      sx={{
        background: color,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 300,
        width: 350,
        borderRadius: 1,
        boxShadow: 2,
        cursor: 'pointer',
        '&:hover': {
          background: darken(color, 0.25),
          boxShadow: 5,
        },
        '&:focus': {
          outline: `2px solid ${colors.grey[700]}`,
          outlineOffset: '2px',
          background: darken(color, 0.25),
          boxShadow: 5,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: 9,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'end',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 105,
            height: 105,
            borderRadius: '50%',
            background: 'rgba(0,0,0,0.2)',
            boxSizing: 'border-box',
          }}
        >
          {icon}
        </Box>
      </Box>
      <Typography
        variant="subtitle1"
        align="center"
        sx={{ color: theme.palette.common.white, flex: 3, pt: 4 }}
      >
        {title}
      </Typography>
    </Box>
  )
}
